import axios from "axios";
export const lookupService = {
  getCountries,
  getDateFormats,
  getFiscalYears,
  getIndustries,
  getLanguages,
  getTimeZones
};

// const API_URL = process.env.REACT_APP_API_URL;
const API_URL = process.env.REACT_APP_API_URL;

function getCountries() {
  return axios
    .get(API_URL + `lookup/countries`)

    .then(countries => {
      // store user details and token in local storage to keep user logged in between page refreshes
      localStorage.setItem("countries", JSON.stringify(countries));
      return countries;
    });
}

function getDateFormats() {
  return axios
    .get(API_URL + `lookup/date-formats`)

    .then(dateFormats => {
      // store user details and token in local storage to keep user logged in between page refreshes
      localStorage.setItem("dateFormats", JSON.stringify(dateFormats));
      return dateFormats;
    });
}

function getFiscalYears() {
  return axios
    .get(API_URL + `lookup/fiscal-years`)

    .then(fiscalYears => {
      // store user details and token in local storage to keep user logged in between page refreshes
      localStorage.setItem("fiscalYears", JSON.stringify(fiscalYears));
      return fiscalYears;
    });
}

function getIndustries() {
  return axios
    .get(API_URL + `lookup/industries`)

    .then(industries => {
      // store user details and token in local storage to keep user logged in between page refreshes
      localStorage.setItem("industries", JSON.stringify(industries));
      return industries;
    });
}

function getLanguages() {
  return axios
    .get(API_URL + `lookup/languages`)

    .then(languages => {
      // store user details and token in local storage to keep user logged in between page refreshes
      localStorage.setItem("languages", JSON.stringify(languages));
      return languages;
    });
}

function getTimeZones() {
  return axios
    .get(API_URL + `lookup/time-zones`)

    .then(timeZones => {
      // store user details and token in local storage to keep user logged in between page refreshes
      localStorage.setItem("timeZones", JSON.stringify(timeZones));
      return timeZones;
    });
}
